import React from 'react';
import { FormattedNumber } from 'react-intl';

import type { IPartnerDetailsCommissions } from 'v2/interfaces/reports/partnerCommissions';

import { useStyles } from './styles';

interface IProps {
  commissions: IPartnerDetailsCommissions[];
}

export const CardsMobile = ({ commissions }: IProps) => {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      {commissions?.map((commission) => (
        <div key={commission.product.id} className={classes.card}>
          <header className={classes.cardHeader}>
            <p className={classes.productName}>
              {commission.product.id} - {commission.product.title}
            </p>
          </header>
          <div className={classes.cardContent}>
            <strong className={classes.detailKey}>
              Comissões: <span className={classes.detailValue}>{commission.total_commissions}</span>
            </strong>
            <strong className={classes.detailKey}>
              Ganho líquido:{' '}
              <span className={classes.detailValue}>
                <FormattedNumber value={commission.net_gain} format='BRL' />
              </span>
            </strong>
          </div>
        </div>
      ))}
    </section>
  );
};
